import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/report/:tongueCaseId',
    meta: { title: '健康报告' },
    name: 'report',
    component: () => import('../views/report')
  },
  {
    path: '/registerPartner',
    name: 'registerPartner',
    meta: { title: '合伙人注册' },
    component: () => import('../views/register/registerPartner')
  },
  {
    path: '/registerShop',
    name: 'registerShop',
    meta: { title: '门店注册' },
    component: () => import('../views/register/registerShop')
  },
  {
    path: '/success',
    name: 'success',
    meta: { title: '提交成功' },
    component: () => import('../views/success')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  // base: '/invite/',
  routes,
})

export default router
